import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { validatePassword } from "service1/authService";

const HOST_TOKEN = "my-secret-token";

type UsePasswordReturn = {
  password: string;
  setPassword: (value: string) => void;
  handleSubmit: () => void;
  isValid: boolean;
  firstName: string;
};

export default function usePassword(): UsePasswordReturn {
  const [password, setPassword] = useState<string>("");

  const navigate = useNavigate();
  const location = useLocation();

  const { name = "" } =
    (location.state as { name?: string }) || {};

  const handleSubmit = async (): Promise<void> => {
    if (!password) return;

    try {
      const userId = sessionStorage.getItem("userId");

      if (!userId) {
        console.log("No userId found");
        return;
      }

      //  pass federation token directly
      const data = await validatePassword(
        {
          userId: Number(userId),
          password,
        },
        HOST_TOKEN
      );

      if (Number(data.statusType) === 1) {
        if (data.token) {
          sessionStorage.setItem("token", data.token);
        }

        navigate("/posts");
      } else {
        console.log("Invalid password");
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  return {
    password,
    setPassword,
    handleSubmit,
    isValid: password.length > 0,
    firstName: name,
  };
}